import { createApp } from 'vue'
import PreviewDialog from '@/components/PreviewDialog.vue'

let instance = null

export default {
  install(app) {
    if (!instance) {
      const container = document.createElement('div')
      document.body.appendChild(container)

      const previewApp = createApp(PreviewDialog)
      instance = previewApp.mount(container)
    }

    app.config.globalProperties.$preview = {
      show: (src) => instance.show(src),
      close: () => instance.close(),
    }

    // 也可以暴露给外部直接 import 使用
    app.provide('preview', instance)
  },
}
